import Call from '../Call';

const BidderClickLog = {
    getAvailableSources() {
        return Call(`bidderClickLog/sources`);
    }
};

export default BidderClickLog;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderClickLog.js